export default "__VITE_PUBLIC_ASSET__73a972c4__"